import React from "react"
import { FlexContainer } from "../../styled/layout.styled"
import styled from "@emotion/styled"
import { H1, H2 } from "../../styled/typography.styled"
import ExperienceEducationList from "./ExperienceEducationList"
import SkillsList from "./SkillsList"
import {
  EXPERIENCE_EDUCATION_LIST,
  RESUME_DETAILS,
  SKILLS_LANGUAGES_LIST,
} from "../../constants/data.constants"
import DetailsCard from "./DetailsCard"

export const StyledFlexContainer = styled(FlexContainer)`
  background-color: #252525;
  border-top: 2px solid #333;
  border-bottom: 2px solid #333;
  position: relative;
  top: 0;
  width: 100%;
  left: -70px;
  right: 0;
  padding: 65px 70px;

  @media only screen and (max-width: 970px) {
    left: -40px;
    padding: 40px 40px 65px 40px;
  }
`
const StyledFlexContainerList = styled(FlexContainer)`
  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`

export const StyledH2 = styled(H2)`
  color: #d5d5d5;
  font-size: 14px;
  position: absolute;
  top: 30px;
  right: 70px;
  font-family: Poppins, Helvetica, sans-serif;
  font-weight: 300;
  font-style: normal;
  letter-spacing: 0;
  @media only screen and (max-width: 970px) {
    top: unset;
    right: unset;
    bottom: 40px;
    left: 44px;
  }
`

const ResumeMain = () => {
  const experienceDate = new Date().getFullYear() - 2018

  return (
    <>
      <StyledFlexContainer flexWrap="wrap">
        <H1>Resume</H1>
        <StyledH2>{experienceDate} Years of Experience</StyledH2>
      </StyledFlexContainer>
      <StyledFlexContainerList
        justifyContent="space-between"
        FlexWrap="wrap"
        padding="60px 0 60px 0"
      >
        {EXPERIENCE_EDUCATION_LIST.map(({ id, topic, list }) => (
          <ExperienceEducationList key={id} topic={topic} list={list} />
        ))}
      </StyledFlexContainerList>
      <StyledFlexContainerList justifyContent="space-between" FlexWrap="wrap">
        {SKILLS_LANGUAGES_LIST.map(({ topic, id, skillsList }) => (
          <SkillsList key={id} topic={topic} skillsList={skillsList} />
        ))}
      </StyledFlexContainerList>
      <StyledFlexContainerList
        padding="60px 0 0 0"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        {RESUME_DETAILS.map(({ id, topic, names, link }) => (
          <DetailsCard key={id} topic={topic} names={names} link={link} />
        ))}
      </StyledFlexContainerList>
    </>
  )
}

export default ResumeMain
